import { assert_string_object_id, assert_type_boolean } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestUserTaskUpdateVisibility extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_USER_TASK_UPDATE_VISIBILITY;

  /*
   *
   */
  user_task_id!: string;
  is_hidden!: boolean;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    assert_string_object_id(this.user_task_id);
    assert_type_boolean(this.is_hidden);
  }
}
